/**
 * מנרמל תגובות API שעלולות להיות מערך, אובייקט עם ‎data/items‎, או ערך לא צפוי.
 * שימוש לפני ‎.filter‎ / ‎.map‎ על תוצאות ‎useQuery‎.
 */
export function asArray(value) {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") {
    if (Array.isArray(value.data)) return value.data;
    if (Array.isArray(value.notifications)) return value.notifications;
    if (Array.isArray(value.items)) return value.items;
    if (Array.isArray(value.results)) return value.results;
  }
  return [];
}
